import { Component, OnDestroy, OnInit } from '@angular/core';
import { SidebarContentComponent } from '../sidebar/sidebar-content-component';
import { ApplicationStateService } from '../../../services/application-state.service';
import { OfflineModeService } from '../../../services/offline-mode.service';
import { BookFeatureActivationService } from '../../../services/book-feature-activation.service';
import { CommunicationService } from '../../../services/communication.service';
import { SidebarService } from '../../../services/sidebar.service';
import { SidebarChangedEvent } from '../../../utils/events/sidebar-changed-event';
import { Subscription } from 'rxjs';
import { AssetPipe } from '../../../pipes/asset.pipe';
import { BackgroundImageDirective } from '../../../directives/background-image.directive';
import { ViewmodeSwitcherComponent } from '../../topbar/viewmode-switcher/viewmode-switcher.component';
import {
    BookAdditionalsComponent
} from '../../bookviewer/pages/modal-container/materials-modal/book-additionals/book-additionals.component';
import { FeatureMenuComponent } from '../../topbar/feature-menu/feature-menu.component';
import {
    EditionsDropdownComponent
} from '../../topbar/edition-switcher/edition-switcher-modal-content/editions-dropdown/editions-dropdown.component';
import { BookInfoComponent } from '../../utils/book-info/book-info.component';
import {
    LastUsedBooksComponent
} from '../../bookviewer/pages/modal-container/my-books-modal/last-used-books/last-used-books.component';

@Component({
    selector: 'app-mobile-books',
    templateUrl: './mobile-books.component.html',
    styleUrls: ['./mobile-books.component.scss'],
    standalone: true,
    imports: [
        AssetPipe,
        BackgroundImageDirective,
        BackgroundImageDirective,
        BackgroundImageDirective,
        BackgroundImageDirective,
        BackgroundImageDirective,
        BackgroundImageDirective,
        BackgroundImageDirective,
        BackgroundImageDirective,
        BackgroundImageDirective,
        ViewmodeSwitcherComponent,
        BookAdditionalsComponent,
        FeatureMenuComponent,
        EditionsDropdownComponent,
        BookInfoComponent,
        LastUsedBooksComponent
    ]
})
export class MobileBooksComponent implements OnInit, OnDestroy, SidebarContentComponent {

    rsToggleImgSrc: string;
    rsTooltipText = 'Vorlesefunktion deaktiviert';
    rsSubscription: Subscription;

    constructor(public applicationStateService: ApplicationStateService,
                public featureActivationService: BookFeatureActivationService,
                private communicationService: CommunicationService,
                private sidebarService: SidebarService,
                private offlineModeService: OfflineModeService) {

        this.rsSubscription = this.communicationService.readspeakerVisibilityToggledSource$.subscribe(ele => {
            if (this.featureActivationService.readspeakerElementsVisible) {
                this.rsToggleImgSrc = 'button-audiobook-active.png';
                this.rsTooltipText = 'Vorlesefunktion<br/><strong>aktiviert</strong>';
            } else {
                this.rsToggleImgSrc = 'button-audiobook-inactive.png';
                this.rsTooltipText = 'Vorlesefunktion <br/><strong>deaktiviert</strong>';
            }
        });
    }

    ngOnInit(): void {
        // eslint-disable-next-line max-len
        if (this.featureActivationService.readspeakerElementsVisible) {
            this.rsToggleImgSrc = 'button-audiobook-active.png';
        } else {
            this.rsToggleImgSrc = 'button-audiobook-inactive.png';
        }
    }

    ngOnDestroy(): void {
        this.rsSubscription.unsubscribe();
    }

    createOfflineVersion(): void {
        if (this.applicationStateService.userData.isTeacher) {
            this.offlineModeService.getOfflineVersion();
        }
    }

    toggleReadspeaker(): void {
        this.featureActivationService.readspeakerActivated = !this.featureActivationService.readspeakerActivated;
        this.featureActivationService.readspeakerElementsVisible = !this.featureActivationService.readspeakerElementsVisible;
        this.communicationService.toggleReadspeakerVisibility();
        if (this.featureActivationService.readspeakerElementsVisible) {
            this.rsToggleImgSrc = 'button-audiobook-active.png';
            this.rsTooltipText = 'Vorlesefunktion<br/><strong>aktiviert</strong>';
        } else {
            this.rsToggleImgSrc = 'button-audiobook-inactive.png';
            this.rsTooltipText = 'Vorlesefunktion <br/><strong>deaktiviert</strong>';
        }

        ($('.rs-toggle-button') as any).tooltip('hide')
            .attr('data-bs-original-title', this.rsTooltipText)
            .tooltip('show');
    }

    close(): void {
        this.sidebarService.triggerSidebarChangeEvent(new SidebarChangedEvent(false));
    }
}
